<div>
    <uilab-mat-chip-listbox #chips aria-label="Theme Selection" selectable>
        <uilab-mat-chip-option
            [highlighted]="lightTheme"
            (click)="select('light')"
            appearance="outline"
            selected
            >Light</uilab-mat-chip-option
        >
        <uilab-mat-chip-option
            [highlighted]="darkTheme"
            (click)="select('dark')"
            appearance="outline"
            >Dark</uilab-mat-chip-option
        >
        <uilab-mat-chip-option
            [highlighted]="interactive"
            (click)="select('interactive')"
            appearance="outline"
            >Interactive</uilab-mat-chip-option
        >
    </uilab-mat-chip-listbox>
    <div>
        <uilab-mat-checkbox class="checkbox" (change)="disable()" [checked]="disabled"
            >Disabled</uilab-mat-checkbox
        >
    </div>
</div>
